import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '../../../../components/ui/Card'
import { DataTableNew } from '../../../../components/table-components/data-table'
import DataTableColumnHeader from '../../../../components/table-components/data-table-column-header'
import IconAdd from '../../../../components/svg/IconAdd'
import AssetModel from './models/AssetModel'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAssetAction } from '../../../../store/actions/admin/assetAction'
import { useNavigate } from 'react-router-dom'
import { DotsHorizontalIcon, Pencil2Icon } from '@radix-ui/react-icons'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../../components/ui/dropdown'
import { Button } from '../../../../components/ui/button';
import useDebounce from '../../../../hooks/useDebounce'

const AssetsContent = () => {
    const { assetData } = useSelector(state => state)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [editedData, setEditedData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1)
    const [perPage, setPerPage] = useState(10);
    const [firstTime, setFirstTime] = useState(true)
    const [onSearchValue, setOnSearchValue] = useState("");
    const [search, setSearch] = useState("");
    const [sortingValue, setSortingValue] = useState(1);
    const [addAssetsModel, setAddAssetsModel] = useState(false);
    // const [openModel, setOpenModel] = useState(false);

    useEffect(() => {
        setFirstTime(false)
    }, [])

    useEffect(() => {
        if (addAssetsModel === false) {
            setEditedData(null)
        }
    }, [addAssetsModel])

    const onChange = (filter) => {
        setCurrentPage(filter?.page)
        setPerPage(filter?.perPage)
        const filterData = {
            ...filter,
            search: search,
            sortCountry: sortingValue
        }
        dispatch(fetchAssetAction(filterData))
    }

    useEffect(() => {
        const filterData = {
            page: currentPage,
            perPage: perPage,
            search,
            sortCountry: sortingValue
        }
        !firstTime && dispatch(fetchAssetAction(filterData))

    }, [search, sortingValue]);

    const onShowAssets = () => {
        setAddAssetsModel(true)
    }

    const onHideAssets = () => {
        setAddAssetsModel(false)
    }

    const handleEditAsset = (data) => {
        setEditedData(data)
        setAddAssetsModel(true)
    }

    const rightHeaderButtons = [
        {
            icon: <IconAdd className="w-4 h-4 " />,
            text: 'Add Asset',
            onClick: () => { onShowAssets() },
            variant: '',
            additionalClass: ""
        },

    ]

    const debouncedText = useDebounce(onSearchValue, 1000);

    useEffect(() => {
        setSearch(debouncedText);
    }, [debouncedText]);

    const onSearchChange = (e) => {
        setOnSearchValue(e?.target?.value)
    }

    const navigatePage = (rows) => {
        
        const slugName = `${rows?.data?.country?.alpha2Code}-${rows?.slug}-${rows?.curve}`
        const navigatePath = decodeURIComponent(slugName?.trim()?.replace(/\s+/g, "-"))
        navigate('/admin/data/asset/' + navigatePath, {
            state: {
                data: rows
            }
        })
    }

    const data = assetData && assetData?.records?.length ? assetData.records.map((item) => {
        return {
            id: item._id,
            Asset_Id: item?.assetId ?? "-",
            Name: item?.name,
            country: item?.country?.countryName || '-',
            currency: item?.currency?.currency || '-',
            curve: item?.interestRateDataType?.type || '-',
            week: item?.interestRateDataTypeAsset?.week ?? '-',
            month: item?.interestRateDataTypeAsset?.month ?? '-',
            year: item?.interestRateDataTypeAsset?.year ?? '-',
            value: item?.interestRateDataTypeAsset?.value ?? "-",
            tenure: item?.interestRateDataTypeAsset?.maturity || '-',
            slug: item?.interestRateDataTypeAsset?.slug || '-',
            description: item?.description || '-',
            data: item
        }
    }) : [];


    const columns = [
        {
            accessorKey: "Asset_Id",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Asset Id" setSortingValue={setSortingValue} />
                <>Asset Id</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Asset_Id}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "Name",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Name" setSortingValue={setSortingValue} />
                <>Name</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Name}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "country",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Country" setSortingValue={setSortingValue} />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.country}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "curve",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Curve" setSortingValue={setSortingValue} />
                <>Curve</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.curve}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "tenure",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Tenor" setSortingValue={setSortingValue} />
                <>Tenor</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center text-[#2487EE] hover:underline cursor-pointer' onClick={(e) => { navigatePage(row?.original); }} >{row?.original?.tenure ?? "-"}</span>
            },
            enableSorting: true,

        },

        {
            accessorKey: "value",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Rate" setSortingValue={setSortingValue} />
                <>Rate</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.value}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "currency",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Currency" setSortingValue={setSortingValue} />
                <>Currency</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.currency}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "week",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Week" setSortingValue={setSortingValue} />
                <>Week</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.week}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "month",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Month" setSortingValue={setSortingValue} />
                <>Month</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.month}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "year",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Year" setSortingValue={setSortingValue} />
                <>Year</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.year}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "description",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Description" setSortingValue={setSortingValue} />
                <>Description</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center  min-w-[300px]'>{row?.original?.description}</span>
            },
            enableSorting: true,
        },
        {
            id: "actions",
            enableHiding: false,
            header: <span className="flex items-center justify-center">Action</span>,
            cell: ({ row }) => {
                return (
                    <div className="flex items-center justify-center">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" className="p-0">
                                    <span className="sr-only">Open menu</span>
                                    <DotsHorizontalIcon strokeWidth={"2.2"} className="h-5 w-5 text-textV2" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="center" >
                                <DropdownMenuItem className={`text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2`} onClick={() => {
                                    setEditedData(row?.original);
                                    setAddAssetsModel(true);
                                }}> <span className='w-5 h-5 bg-themeV2/10 flex items-center justify-center rounded-[4px]'><Pencil2Icon strokeWidth={"2.2"} className='text-themeV2 w-4 h-4' /> </span> Edit </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                )
            },
        }
    ];


    return (
        <div className='p-5'>
            <Card className="bg-white p-4">
                <CardContent className="p-2">
                    <DataTableNew columns={columns} data={data} onChange={onChange} filterName={'Name'}
                        isRightNew={true}
                        isOldHeaderHide={true}
                        onSearchChange={onSearchChange}
                        isRightSearch={true}
                        isRightHeaderButtons={true}
                        rightHeaderButtons={rightHeaderButtons}
                        isLeftHeaderButtons={false}
                        isRight={true} />

                    <AssetModel
                        show={addAssetsModel}
                        onHide={() => onHideAssets(false)}
                        editedData={editedData}
                    />
                </CardContent>
            </Card>
        </div>
    )
}


export default AssetsContent
